import type { DeskWithComments } from '../api/commentsApi';

export const canWriteComments = (desk: DeskWithComments | null | undefined, role: string | undefined): boolean =>
  desk?.comments?.write?.some((r) => r === role) ?? false;

export const canReadComments = (desk: DeskWithComments | null | undefined, role: string | undefined): boolean =>
  canWriteComments(desk, role) || (desk?.comments?.read?.some((r) => r === role) ?? false);
